export const SET_BLOCK_ATTRIBUTES = 'SET_BLOCK_ATTRIBUTES';
export const REORDER_BLOCKS = 'REORDER_BLOCKS';
export const INSERT_BLOCK = 'INSERT_BLOCK';
export const SET_CURRENT_BLOCK = 'SET_CURRENT_BLOCK';
export const DELETE_BLOCK = 'DELETE_BLOCK';
export const SET_CURRENT_CHILD_BLOCK = 'SET_CURRENT_CHILD_BLOCK';
export const SETUP_STORE = 'SETUP_STORE';
export const SET_BLOCKS = 'SET_BLOCKS';
export const STORE_KEY = 'quillForms/block-editor';
